import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaPcon } from './types';

export const INITIAL_STATE: ConsultaPcon = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaPcon {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PCON_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.CONSULTA_PCON_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_PCON_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}

			case Types.CONSULTA_PCON_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
